// extracted by mini-css-extract-plugin
export var button = "_cy-4";
export var hasDarkBackground = "_cy-7";
export var hasLightBackground = "_cy-6";
export var iconWrapper = "_cy-0";
export var large = "_cy-2";
export var medium = "_cy-1";
export var small = "_cy-5";
export var xsmall = "_cy-3";